export const about = {
    "title": "About <span>HRD</span>",
    "paragraphs": [
      "At HRD Painting & Restoration, we bring over 20 years of expertise in high-rise restoration, commercial painting, and building envelope renewal across Metro Vancouver. Our mission is simple: to protect, restore, and enhance your building with precision, durability, and long-lasting value.",
      "We take pride in delivering exceptional craftsmanship and lasting protection while ensuring minimal disruption to your operations. Using premium materials, advanced techniques, and eco-friendly solutions, we help buildings withstand the elements while restoring their beauty and strength.",
      "From exterior painting and waterproofing to structural repairs and full-scale restorations, HRD provides tailored solutions that stand the test of time. With a steadfast commitment to safety, efficiency, and compliance, we get the job done right - on time and to the highest standard.",
      "Trust HRD to bring your building back to life - stronger than ever."
    ],
    "imageUrl": "/assets/imgs/about/fondo-about.png",
  
    "topSection": {
      "main": "Elevating Standards in Building Envelope Renewal,",
      "highlight": "High-Rise Painting & Restoration."
    },
    "bottomSection": {
      "highlight": "COMPREHENSIVE SOLUTIONS FOR",
      "rest": "High-Rise and Commercial Properties"
    },
    "workSection": {
      "bgImage": "/assets/imgs/about/fondo.jpg",
      "bgColor": "#EE1B24",
      "heading": "Take a Look",
      "highlight": "at our Work",
      "description": "Whether you need immediate leak investigation and remediation or are planning an interior renovation and budgeting for the future, we’re here to help.",
      "ctaLink": "/projects"
    }
  };
  